import React, { PureComponent } from 'react'
import _ from 'lodash'
import { Dimmer, Loader, Header, Grid, Button, Icon, Card } from 'semantic-ui-react'
import DriverSegmentForm from '../forms/driverSegmentForm'
import AddDriverToSegmentForm from '../forms/addDriverToSegmentForm'
import GroupRow from './driverSegmentRow'
import ListDriverInSegmentModal from './listDriverInSegmentModal'

class DriverSegments extends PureComponent {
  state = {
    modalCreateSegment: false,
    driverSegmentData: null,
    action: null,
    modalViewDriverSegmentDetail: false,
    modalAddDriver: false,
    driverSegment: {}
  }

  onAdd = () => {
    this.setState({
      driverSegmentData: { name: "", id: "" },
      modalCreateSegment: true,
      action: 'new'
    })
  }

  onEdit = ({ name, id }) => {
    this.setState({
      driverSegmentData: { name, id },
      modalCreateSegment: true,
      action: 'edit'
    })
  }

  closeForm = () => {
    this.setState({
      modalCreateSegment: false
    })
  }

  onFieldChange = (field, value) => {
    this.setState(prevState => ({
      driverSegmentData: {
        ...prevState.driverSegmentData,
        [field]: value
      }
    }))
  }

  onRemove = driverSegment => {
    const { deleteDriverSegment, drivers } = this.props

    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`Are you sure to remove ${driverSegment.name} ?`)
    const driverInSegment = _.filter(drivers, ['driver_segment', driverSegment.id])

    if (confirm) {
      deleteDriverSegment(driverSegment.id, driverInSegment)
    }
  }

  onAddDriver = driverSegment => {
    this.setState({
      modalAddDriver: true,
      driverSegment,
    })
  }

  onView = driverSegment => {
    this.setState({
      modalViewDriverSegmentDetail: true,
      driverSegment,
    })
  }

  onCloseAddDriver = () => {
    this.setState({ modalAddDriver: false })
  }

  onCloseDriverSegmentDetail = () => {
    this.setState({ modalViewDriverSegmentDetail: false })
  }

  renderDriverSegments = () => {
    const { driverSegments, drivers } = this.props

    return _.map(driverSegments, (driverSegment) => (
      <GroupRow
        driverSegment={driverSegment}
        key={driverSegment.id}
        drivers={_.filter(drivers, ['driver_segment', driverSegment.id])}
        onRemove={() => this.onRemove(driverSegment)}
        onEdit={() => this.onEdit(driverSegment)}
        onAddDriver={() => this.onAddDriver(driverSegment)}
        onView={() => this.onView(driverSegment)}
        onAddIncentive={() => this.onAddIncentive(driverSegment.id)}
      />
    ))
  }

  renderNoDriverSegments = () => {
    return <Header size="small" style={{ padding: 16 }}>No data available</Header>
  }

  onSaveDriverSegment = () => {
    const { driverSegmentData } = this.state
    const { saveDriverSegment } = this.props

    saveDriverSegment(driverSegmentData.id, driverSegmentData, () => {
      this.closeForm()
    })
  }

  onAddIncentive = id => {
    const { history } = this.props

    history.push({
      pathname: `/driver-segments/${id}`,
    })
  }

  renderLoading = () => (
    <Dimmer active inverted style={{ margin: 30 }}>
      <Loader inverted content='Loading' />
    </Dimmer>
  )

  render() {
    const { modalCreateSegment, driverSegmentData, action, modalViewDriverSegmentDetail, modalAddDriver, driverSegment } = this.state
    const { driverSegments, loading, addingDriverSegment, drivers } = this.props

    const renderSegment = _.size(driverSegments) > 0 ? this.renderDriverSegments() : this.renderNoDriverSegments()

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0px 14px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <Header>Driver Segments</Header>
          </div>
          <div style={{ display: 'flex' }}>
            <Button icon color="black" onClick={this.onAdd}>
              <Icon name="add" /> Add Driver Segments
            </Button>
          </div>
        </div>
        <Grid.Row>
          <Card.Group itemsPerRow={2} style={{ marginTop: 16 }}>
            { loading ? this.renderLoading() : renderSegment }
          </Card.Group>
        </Grid.Row>
        {
          driverSegmentData && (
            <DriverSegmentForm
              visible={modalCreateSegment}
              onClose={this.closeForm}
              onFieldChange={this.onFieldChange}
              driverSegmentData={driverSegmentData}
              action={action}
              loading={addingDriverSegment}
              saveDriverSegment={this.onSaveDriverSegment}
            />
          )
        }
        <AddDriverToSegmentForm
          visible={modalAddDriver}
          driverSegments={driverSegments}
          driverSegment={driverSegment}
          drivers={drivers}
          onClose={this.onCloseAddDriver}
        />
        <ListDriverInSegmentModal
          open={modalViewDriverSegmentDetail}
          onClose={this.onCloseDriverSegmentDetail}
          driverSegment={driverSegment}
          drivers={_.filter(drivers, ['driver_segment', driverSegment.id])}
        />
      </div>
    )
  }
}

export default DriverSegments



// WEBPACK FOOTER //
// ./src/components/drivers/views/driverSegments.js